import React, { useContext } from 'react';
import "../Styles/CloseStudyCss.css";
import { useTranslation } from 'react-i18next';
import { Dropdown, TextField } from '@fluentui/react';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
  } from "react-device-detect";
import themeContext from '../../../../context/theme/ThemeContext';

const CloseStudyBody = (props) => {
    const [t] = useTranslation();
    const {themeName}=useContext(themeContext);

    const dropdownStyles = {
        dropdownItemsWrapper: {
            maxHeight: '108px', // Set the maximum height for the dropdown list
            overflowY: 'auto',  // Enable vertical scroll if list exceeds maxHeight
            colorScheme:`${themeName==='light'?'none':'inherit'}`
        }
    };

  return (
    <div className="close-study-container">
                <div className="ms-Grid" dir="ltr">
                        <div className='ms-Grid-row'>
                            <Dropdown
                                // options={props.reasonsList}
                                options={[{ key: 'select', text: 'Select' }, ...props.reasonsList]}
                                // defaultSelectedKey={props.reasonsList[0].text}
                                defaultSelectedKey={props.values.reason || 'select'} 
                                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                onChange={ props.handleChangeReason }
                                label= {t("close-study.reason-to-close-study")}
                                // value={props.reason}
                                //styles={isMobile?{}:dropdownStyles}
                                name="reason"
                                errorMessage={(props.values.reason === 'select') ? "Please select a reason" : props.errors.reason}
                                styles={{
                                    ...(!isMobile ? dropdownStyles : {}),
                                    errorMessage: { fontWeight: 'bold', color: 'red' }
                                }}
                            />
                            {props.isOtherReason &&<TextField
                                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12" 
                                name="otherReason"
                                onChange={(e) =>{
                                    if(props.isOtherReason){
                                        props.handleChange(e);
                                    }
                                }}
                                value={props.values.otherReason}
                                label= {t("close-study.other")}
                                errorMessage={props.errors.otherReason}
                            />}
                    </div>
                </div>
            </div>
  )
}

export default CloseStudyBody